import { render, staticRenderFns } from "./TabelaDashboardSolicitacoes.vue?vue&type=template&id=03aedf32&scoped=true"
import script from "./TabelaDashboardSolicitacoes.vue?vue&type=script&lang=js"
export * from "./TabelaDashboardSolicitacoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03aedf32",
  null
  
)

export default component.exports